import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { IProductionLine, IWorkOrder, WorkOrderMissionType } from "@/models";

@Component({
    name: "ProductionLine",
})

export default class ProductionLine extends Vue {
    @Prop({ required: true })
    public productionLine: IProductionLine;

    @Prop({ required: true })
    public workOrder: IWorkOrder;

    @Prop({ required: true, type: String })
    public productionLineRoute: string;

    @Prop({ required: true, type: String })
    public workOrderRoute: string;

    public showProgress: boolean;

    @Prop({ required: false, type: Boolean, default: false })
    public showQuantity: boolean;

    @Prop({ required: false, type: Number })
    public workOrderMissionType: WorkOrderMissionType;

    public get progress(): number {
        if (this.workOrder) {
            const totalDuration = new Date(this.workOrder.estimatedEndDate).getTime() - new Date(this.workOrder.estimatedStartDate).getTime();
            const currentDuration = this.workOrder.startDate ? this.$store.state.app.now.getTime() - new Date(this.workOrder.startDate).getTime() : 0;
            const progress = Math.round(currentDuration / totalDuration * 100);
            return progress > 100 ? 100 : progress;
        }
        return 0;
    }

    public get notification(): number {
        if (this.workOrder && this.workOrderMissionType) {
            return this.workOrder.workOrderMissions.length;
        }
        return 0;
    }

    public get quantity(): number {
        if (this.workOrder && this.workOrder.quantityPerPallet > 0) {
            return Math.round(this.workOrder.quantityRequested / this.workOrder.quantityPerPallet);
        }
        return 0;
    }

    public constructor() {
        super();
        this.showProgress = false;
    }

    public goProductionLine(): void {
        this.$router.push({ name: this.productionLineRoute, params: { productionLineId: this.productionLine.productionLineId.toString() } });
    }

    public goWorkOrder(): void {
        if (this.workOrder) {
            this.$router.push({ name: this.workOrderRoute, params: { workOrderId: this.workOrder.workOrderId.toString() } });
        }
    }
}
